import React from 'react';
import './App.css';
import ImagesGallery from './component/ImageGallery';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <ImagesGallery/>
    </div>
  );
}

export default App;
